import { useEffect, useState } from "react";
import "./ExcluirEmail.css";

export default function ExcluirEmail({ open, titulo, onClose, onConfirmar, onConfirm }) {
  if (!open) return null;

  const [busy, setBusy] = useState(false);
  const submit = onConfirmar || onConfirm || (() => {});

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const onKeyDown = (e) => {
    if (e.key === "Escape") onClose?.();
    if (e.key === "Enter" && !busy) handleConfirm();
  };

  async function handleConfirm() {
    try {
      setBusy(true);
      await Promise.resolve(submit());
      onClose?.();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="emdel-bg" onKeyDown={onKeyDown} tabIndex={-1}>
      <div className="emdel-box" role="dialog" aria-modal="true" aria-label="Excluir e-mail">
        <header className="emdel-head">
          <h3 className="emdel-title">Excluir e-mail</h3>
          <button className="emdel-x" type="button" onClick={onClose} aria-label="Fechar">
            x
          </button>
        </header>

        <div className="emdel-body">
          Tem certeza que deseja <strong>excluir</strong> "{titulo || "este e-mail"}"?
        </div>

        <footer className="emdel-foot">
          <button className="emdel-btn" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="emdel-btn emdel-btn-danger" type="button" onClick={handleConfirm} disabled={busy}>
            {busy ? "Excluindo..." : "Excluir"}
          </button>
        </footer>
      </div>
    </div>
  );
}
